import { useState } from "react";
import StarIcon from "./StarIcon";
import styles from "./StarRating.module.css";

/**
 * value: current rating (1-5, or 0 for none selected)
 * onChange: if provided, renders as an interactive picker
 * size: pixel size per star
 */
function StarRating({ value = 0, onChange, size = 24, label }) {
  const [hovered, setHovered] = useState(0);
  const interactive = typeof onChange === "function";
  const display = interactive && hovered ? hovered : value;

  return (
    <div
      className={styles.row}
      role={interactive ? "radiogroup" : "img"}
      aria-label={label || `${value} out of 5 stars`}
    >
      {[1, 2, 3, 4, 5].map((n) =>
        interactive ? (
          <button
            key={n}
            type="button"
            className={styles.starBtn}
            style={{ width: size, height: size }}
            aria-label={`${n} star${n > 1 ? "s" : ""}`}
            aria-pressed={value === n}
            onClick={() => onChange(n)}
            onMouseEnter={() => setHovered(n)}
            onMouseLeave={() => setHovered(0)}
          >
            <StarIcon filled={n <= display} className={styles.star} />
          </button>
        ) : (
          <StarIcon
            key={n}
            filled={n <= display}
            className={styles.starStatic}
            style={{ width: size, height: size }}
          />
        )
      )}
    </div>
  );
}

export default StarRating;
